var _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Location",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "images",
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#2c347f"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pin",
    transform: "translate(-496 -486)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    d: "M516,527.558a1.5,1.5,0,0,1-1.092-.475c-2.381-2.551-7.916-9.035-7.906-14.151a9,9,0,0,1,18,0c0,5.087-5.53,11.588-7.907,14.147a1.5,1.5,0,0,1-1.093.478ZM516,505a7.976,7.976,0,0,0-8,7.933c-.01,4.894,5.843,11.545,7.637,13.467a.488.488,0,0,0,.361.158h0a.489.489,0,0,0,.361-.159c1.792-1.929,7.64-8.6,7.64-13.466A7.976,7.976,0,0,0,516,505Z",
    transform: "translate(0 -10)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    d: "M516.432,518.43a4.932,4.932,0,1,1,4.932-4.932A4.938,4.938,0,0,1,516.432,518.43Zm0-8.768a3.836,3.836,0,1,0,3.836,3.836A3.84,3.84,0,0,0,516.432,509.663Z",
    transform: "translate(-0.5 -10.711)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.b26909e3ed224dcca663fe6dc35aeda2.svg";
export { ForwardRef as ReactComponent };